export default "__VITE_ASSET__CBiaSmog__"